{
  "//vg-binding": "CONTEXT:decisions=P6.1.D-28,P6.1.D-20 | INTERFACE-STANDARDS:error-shape",
  "page": {
    "title": "Teams",
    "subtitle": "Group stores into teams — each team sees only its own data and budget"
  },
  "actions": {
    "create": "Create team",
    "edit": "Edit",
    "deactivate": "Deactivate team"
  },
  "col": {
    "team": "Team",
    "stores": "Stores",
    "members": "Members",
    "spending": "Spending",
    "status": "Status",
    "actions": "Actions"
  },
  "cell": {
    "stores": "{{count}} stores",
    "storesOne": "{{count}} store"
  },
  "status": {
    "Active": "Active",
    "Inactive": "Inactive"
  },
  "menu": {
    "edit": "Edit",
    "deactivate": "Deactivate team"
  },
  "unassigned": {
    "count": "{{count}} stores not assigned to any team",
    "countOne": "{{count}} store not assigned to any team",
    "hint": "Only you and admins can see their data until assigned",
    "assign": "Assign to team"
  },
  "form": {
    "createTitle": "Create team",
    "editTitle": "Edit team",
    "name": "Team name",
    "namePlaceholder": "e.g. US Market",
    "nameRequired": "Enter a team name",
    "stores": "Stores",
    "storesPlaceholder": "Assign at least one store",
    "storesHint": "Assign at least one store",
    "storesRequired": "Select at least one store",
    "teamLead": "Team lead",
    "teamLeadPlaceholder": "Select a team lead",
    "leadRequired": "Select a team lead",
    "spendingLimit": "Spending limit",
    "spendingLimitHint": "Leave empty for no limit",
    "save": "Save",
    "saving": "Saving..."
  },
  "confirm": {
    "deactivate": {
      "title": "Deactivate this team?",
      "body": "All stores will be released to Unassigned and members moved to no-team. This can be reversed by reassigning them later.",
      "confirm": "Deactivate team",
      "cancel": "Cancel"
    }
  },
  "toast": {
    "created": "Team created",
    "updated": "Team updated",
    "deactivated": "Team deactivated",
    "storesAssigned": "Stores assigned",
    "createFailed": "Could not create team",
    "updateFailed": "Could not update team",
    "deactivateFailed": "Could not deactivate team",
    "duplicateName": "A team with this name already exists"
  },
  "empty": {
    "title": "No teams yet",
    "subtitle": "Create a team to group your stores and control access and budget.",
    "cta": "Create your first team"
  },
  "error": {
    "loadFailed": "Could not load teams.",
    "retry": "Retry",
    "forbidden": {
      "title": "Access denied",
      "body": "You don't have permission to manage teams. Contact your shop owner."
    }
  },
  "breadcrumb": {
    "settings": "Settings",
    "teams": "Teams"
  },
  "scopeChanged": "Store access changed — refreshing",
  "filter": {
    "searchPlaceholder": "Search teams",
    "status": "Status",
    "statusAll": "All statuses",
    "sort": "Sort"
  },
  "sort": {
    "nameAsc": "Name (A–Z)",
    "nameDesc": "Name (Z–A)",
    "spendDesc": "Highest spend",
    "newest": "Newest"
  }
}
